import { ReactNode, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../../hooks/useAuth";

const navItems = [
  { icon: "ri-dashboard-line", label: "Dashboard", href: "/admin" },
  { icon: "ri-folder-line", label: "Categorias", href: "/admin/categories" },
  { icon: "ri-t-shirt-line", label: "Produtos", href: "/admin/products" },
  { icon: "ri-video-line", label: "Vídeos", href: "/admin/videos" },
  { icon: "ri-settings-3-line", label: "Configurações", href: "/admin/settings" },
];

export default function AdminLayout({ children }: { children: ReactNode }) {
  const { pathname } = useLocation();
  const { signOut } = useAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleSignOut = async () => {
    await signOut();
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen bg-[#FAF8F5] flex">
      {/* Overlay mobile */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/30 z-20 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <aside
        className={`fixed top-0 left-0 h-full w-56 bg-white border-r border-black/8 flex flex-col z-30 transition-transform duration-300 ${
          sidebarOpen ? "translate-x-0" : "-translate-x-full"
        } lg:translate-x-0`}
      >
        {/* SEM LOGO */}
        <div className="px-6 py-5 border-b border-black/8">
          <p className="text-[9px] tracking-[0.2em] text-black/30">
            ADMIN
          </p>
        </div>

        {/* Nav */}
        <nav className="flex-1 px-3 py-4 space-y-0.5">
          {navItems.map((item) => {
            const active = pathname === item.href;
            return (
              <Link
                key={item.href}
                to={item.href}
                onClick={() => setSidebarOpen(false)}
                className={`flex items-center gap-3 px-3 py-2.5 rounded-md text-[11px] tracking-[0.1em] transition-all cursor-pointer ${
                  active
                    ? "bg-black text-white"
                    : "text-black/50 hover:text-black hover:bg-black/5"
                }`}
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className={`${item.icon} text-sm`} />
                </div>
                {item.label}
              </Link>
            );
          })}
        </nav>

        {/* Bottom */}
        <div className="px-3 py-4 border-t border-black/8 space-y-1">
          <Link
            to="/"
            target="_blank"
            className="flex items-center gap-3 px-3 py-2.5 rounded-md text-[11px] tracking-[0.1em] text-black/40 hover:text-black hover:bg-black/5 transition-all cursor-pointer"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-external-link-line text-sm" />
            </div>
            Ver Site
          </Link>

          <button
            onClick={handleSignOut}
            className="w-full flex items-center gap-3 px-3 py-2.5 rounded-md text-[11px] tracking-[0.1em] text-black/40 hover:text-black hover:bg-black/5 transition-all cursor-pointer whitespace-nowrap"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-logout-box-line text-sm" />
            </div>
            Sair
          </button>
        </div>
      </aside>

      {/* Main */}
      <div className="flex-1 lg:ml-56 flex flex-col min-h-screen">
        {/* Top bar mobile SEM LOGO */}
        <div className="lg:hidden flex items-center justify-between px-4 py-3 bg-white border-b border-black/8">
          <button
            onClick={() => setSidebarOpen(true)}
            className="w-8 h-8 flex items-center justify-center cursor-pointer"
          >
            <i className="ri-menu-line text-lg" />
          </button>

          <p className="text-[10px] tracking-[0.2em] text-black/40">
            ADMIN
          </p>

          <div className="w-8" />
        </div>

        {/* Conteúdo */}
        <main className="flex-1 p-6 lg:p-8">{children}</main>
      </div>
    </div>
  );
}